import React, { useState } from 'react';
import { ListItemClickFunction, ListItemRenderFunction, ListProps } from './interface';
import MuiList from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import { palette } from '@src/theme';
import { getTestId } from '@src/utils/testIds';

export const List = <Item,>({
  items,
  keyFn,
  onClick,
  render,
  showDivider = false,
  ...otherProps
}: ListProps<Item>) => {
  return (
    <MuiList disablePadding={true} data-testId={getTestId(otherProps)}>
      {items.map((item) => (
        <ListItem
          key={keyFn(item)}
          item={item}
          onClick={onClick}
          render={render}
          showDivider={showDivider}
        />
      ))}
    </MuiList>
  );
};

type ListItemProps<Item> = {
  item: Item;
  onClick?: ListItemClickFunction<Item>;
  render: ListItemRenderFunction<Item>;
  showDivider: boolean;
};

const ListItem = <Item,>({ item, onClick, render, showDivider }: ListItemProps<Item>) => {
  const [isPressed, setIsPressed] = useState(false);
  const hoverStyle = !!onClick
    ? { backgroundColor: palette.surface['hover+focused'], cursor: 'pointer' }
    : {};

  const onItemClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onClick) {
      onClick(item);
    }
  };
  return (
    <MuiListItem
      sx={{
        borderRadius: 0,
        '&:hover': hoverStyle,
        '&:last-child': { borderBottom: 'none' },
      }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      disablePadding={true}
      divider={showDivider}
      onClick={onItemClick}
    >
      {render(item, { isPressed })}
    </MuiListItem>
  );
};
